import React, { useState } from 'react';
import { FaCheckCircle, FaTimesCircle, FaPlus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import displayINRCurrency from '../helpers/displayCurrency';
import productimg1 from '../assets/productimg1.jpg';
import productimg2 from '../assets/productimg2.jpg';
import productimg3 from '../assets/productimg3.jpg';
import productimg4 from '../assets/productimg4.jpg';
import productimg5 from '../assets/productimg5.jpg';
import productimg6 from '../assets/productimg6.jpg';
import productimg7 from '../assets/productimg7.jpg';
import productimg8 from '../assets/productimg8.jpg';
import productimg9 from '../assets/productimg9.jpg';
import productimg10 from '../assets/productimg10.jpg';
import productimg11 from '../assets/productimg11.jpg';
import productimg12 from '../assets/productimg12.jpg';
import productimg13 from '../assets/productimg13.jpg';
import productimg14 from '../assets/productimg14.jpg';
import productimg15 from '../assets/productimg15.jpg';

const AllProducts = () => {
  const [search, setSearch] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editProduct, setEditProduct] = useState(null);

  const [products, setProducts] = useState([
    { product_id: 1, product_code: "SP001", product_name: "Whisper Ultra Clean Wings", sub_title: "XL+ 44 Pads | 40% Longer & Wider", price: 599, discount: 25, after_discount_price: 449, is_active: true, is_trending: true, image: productimg1 },
    { product_id: 2, product_code: "SP002", product_name: "Stayfree Secure XL Ultra Thin", sub_title: "60 Pads | Dry Cover & Odour Control", price: 799, discount: 30, after_discount_price: 559, is_active: true, is_trending: false, image: productimg2 },
    { product_id: 3, product_code: "SP003", product_name: "Sofy Antibacteria Overnight", sub_title: "XXL 20 Pads | Extra Long 420mm", price: 499, discount: 15, after_discount_price: 424, is_active: false, is_trending: false, image: productimg3 },
    { product_id: 4, product_code: "SP004", product_name: "Whisper Choice Ultra Wings", sub_title: "XL 40 Pads | Magic Gel Protection", price: 450, discount: 20, after_discount_price: 360, is_active: true, is_trending: true, image: productimg4 },
    { product_id: 5, product_code: "SP005", product_name: "Nua Ultra Thin Rash-Free", sub_title: "XL 30 Pads | Plant-Based & Toxin-Free", price: 699, discount: 35, after_discount_price: 454, is_active: true, is_trending: true, image: productimg5 },
    { product_id: 6, product_code: "SP006", product_name: "Paree Super Soft XL", sub_title: "40 Pads | Rash-Free & Quick Absorption", price: 399, discount: 18, after_discount_price: 327, is_active: true, is_trending: false, image: productimg6 },
    { product_id: 7, product_code: "SP007", product_name: "Sirona Rash-Free Cottony", sub_title: "XL+ 20 Pads | Organic Cotton Top", price: 549, discount: 22, after_discount_price: 428, is_active: true, is_trending: true, image: productimg7 },
    { product_id: 8, product_code: "SP008", product_name: "Plush 100% Organic Cotton", sub_title: "XL 25 Pads | Ultra-Thin & Biodegradable", price: 799, discount: 40, after_discount_price: 479, is_active: true, is_trending: true, image: productimg8 },
    { product_id: 9, product_code: "SP009", product_name: "Rio Heavy Flow XXL", sub_title: "10 Pads | Super Absorbent & Leak Proof", price: 299, discount: 10, after_discount_price: 269, is_active: true, is_trending: false, image: productimg9 },
    { product_id: 10, product_code: "SP010", product_name: "Everteen Neem-Safflower XXL", sub_title: "40 Pads | Anti-Rash & Odour Control", price: 649, discount: 25, after_discount_price: 487, is_active: false, is_trending: false, image: productimg10 },
    { product_id: 11, product_code: "SP011", product_name: "Pee Safe Organic Cotton", sub_title: "Regular 10 Pads | Biodegradable", price: 399, discount: 30, after_discount_price: 279, is_active: true, is_trending: true, image: productimg11 },
    { product_id: 12, product_code: "SP012", product_name: "VWash WOW Ultra Thin", sub_title: "XL 30 Pads | Advanced Fluid Lock", price: 499, discount: 20, after_discount_price: 399, is_active: true, is_trending: false, image: productimg12 },
    { product_id: 13, product_code: "SP013", product_name: "Bella Perfecta Ultra Blue", sub_title: "40 Pads | Extra Soft & Breathable", price: 450, discount: 15, after_discount_price: 382, is_active: true, is_trending: true, image: productimg13 },
    { product_id: 14, product_code: "SP014", product_name: "Libresse Ultra Thin", sub_title: "Normal Wings 16 Pads | Flexible Fit", price: 550, discount: 28, after_discount_price: 396, is_active: true, is_trending: false, image: productimg14 },
    { product_id: 15, product_code: "SP015", product_name: "Always Radiant Overnight", sub_title: "Size 4 20 Pads | FlexFoam Scented", price: 899, discount: 32, after_discount_price: 611, is_active: true, is_trending: true, image: productimg15 },
  ]);

  const filtered = products.filter(p =>
    p.product_name.toLowerCase().includes(search.toLowerCase()) ||
    p.product_code.toLowerCase().includes(search.toLowerCase())
  );

  const openCreateModal = () => {
    setEditProduct(null);
    setModalOpen(true);
  };

  const openEditModal = (product) => {
    setEditProduct(product);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditProduct(null);
  };

  const handleSave = (formData) => {
    if (editProduct) {
      setProducts(prev => prev.map(p => p.product_id === editProduct.product_id ? { ...p, ...formData } : p));
      toast.success("Product updated successfully!");
    } else {
      const newProduct = {
        product_id: Math.max(...products.map(p => p.product_id)) + 1,
        ...formData,
        image: productimg1,
      };
      setProducts(prev => [...prev, newProduct]);
      toast.success("Product created successfully!");
    }
    closeModal();
  };

  const ProductModal = () => {
    const [formData, setFormData] = useState(editProduct || {
      product_code: '',
      product_name: '',
      sub_title: '',
      price: '',
      discount: 0,
      is_active: true,
      is_trending: false,
    });

    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;

      setFormData(prev => {
        const newValue = type === 'checkbox' ? checked : value;

        const currentPrice = name === 'price' ? parseFloat(value) || 0 : prev.price;
        const currentDiscount = name === 'discount' ? parseFloat(value) || 0 : prev.discount;

        const afterDiscountPrice = name === 'price' || name === 'discount'
          ? Math.round(currentPrice * (1 - currentDiscount / 100))
          : prev.after_discount_price || 0;

        return {
          ...prev,
          [name]: newValue,
          after_discount_price: afterDiscountPrice
        };
      });
    };

    const onSubmit = (e) => {
      e.preventDefault();
      const finalData = {
        ...formData,
        price: Number(formData.price) || 0,
        discount: Number(formData.discount) || 0,
        after_discount_price: Math.round((Number(formData.price) || 0) * (1 - (Number(formData.discount) || 0) / 100)),
      };
      handleSave(finalData);
    };

    return (
      <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
        <div className='bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-screen overflow-y-auto'>
          <div className='p-6 border-b'>
            <h2 className='text-2xl font-bold text-gray-900'>
              {editProduct ? 'Edit Product' : 'Create New Product'}
            </h2>
          </div>

          <form onSubmit={onSubmit} className='p-6 space-y-5'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>Product Code</label>
                <input type='text' name='product_code' value={formData.product_code} onChange={handleChange} required className='w-full px-4 py-2 border border-gray-300 rounded-lg' />
              </div>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>Product Name</label>
                <input type='text' name='product_name' value={formData.product_name} onChange={handleChange} required className='w-full px-4 py-2 border border-gray-300 rounded-lg' />
              </div>
            </div>

            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>Subtitle</label>
              <input type='text' name='sub_title' value={formData.sub_title} onChange={handleChange} required className='w-full px-4 py-2 border border-gray-300 rounded-lg' />
            </div>

            <div className='grid grid-cols-1 md:grid-cols-3 gap-5'>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>Price (₹)</label>
                <input type='number' name='price' value={formData.price} onChange={handleChange} required min='0' className='w-full px-4 py-2 border border-gray-300 rounded-lg' />
              </div>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>Discount (%)</label>
                <input type='number' name='discount' value={formData.discount} onChange={handleChange} min='0' max='100' className='w-full px-4 py-2 border border-gray-300 rounded-lg' />
              </div>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-1'>Selling Price</label>
                <input
                  type='text'
                  value={displayINRCurrency(Math.round((formData.price || 0) * (1 - (formData.discount || 0) / 100)))}
                  disabled
                  className='w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-lg'
                />
              </div>
            </div>

<div className='flex items-center gap-10 pt-4'>
  {/* Active Toggle */}
  <label className='flex cursor-pointer select-none items-center gap-3'>
    <div className='relative'>
      <input
        type='checkbox'
        name='is_active'
        checked={formData.is_active}
        onChange={handleChange}
        className='sr-only'
      />
      {/* Track - Smaller */}
      <div
        className={`box h-5 w-11 rounded-full shadow-inner transition-colors duration-300 ${
          formData.is_active ? 'bg-pink-600' : 'bg-gray-300'
        }`}
      ></div>
      {/* Knob - Smaller */}
      <div
        className={`dot absolute left-0.5 top-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-md transition-transform duration-300 ${
          formData.is_active ? 'translate-x-6' : ''
        }`}
      >
        <span
          className={`h-4 w-4 rounded-full border-4 transition-colors duration-300 ${
            formData.is_active
              ? 'bg-pink-600 border-pink-600'
              : 'bg-white border-gray-400'
          }`}
        ></span>
      </div>
    </div>
    <span className='text-gray-700 font-medium text-sm'>Active</span>
  </label>

  {/* Trending Toggle */}
  <label className='flex cursor-pointer select-none items-center gap-3'>
    <div className='relative'>
      <input
        type='checkbox'
        name='is_trending'
        checked={formData.is_trending}
        onChange={handleChange}
        className='sr-only'
      />
      {/* Track */}
      <div
        className={`box h-5 w-11 rounded-full shadow-inner transition-colors duration-300 ${
          formData.is_trending ? 'bg-pink-600' : 'bg-gray-300'
        }`}
      ></div>
      {/* Knob */}
      <div
        className={`dot absolute left-0.5 top-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-white shadow-md transition-transform duration-300 ${
          formData.is_trending ? 'translate-x-6' : ''
        }`}
      >
        <span
          className={`h-4 w-4 rounded-full border-4 transition-colors duration-300 ${
            formData.is_trending
              ? 'bg-pink-600 border-pink-600'
              : 'bg-white border-gray-400'
          }`}
        ></span>
      </div>
    </div>
    <span className='text-gray-700 font-medium text-sm'>Trending</span>
  </label>
</div>

            <div className='flex justify-end gap-4 pt-6 border-t'>
              <button type='submit' className='px-6 py-2.5 bg-pink-600 text-white rounded-lg hover:bg-pink-700 font-medium'>
                {editProduct ? 'Update Product' : 'Create Product'}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  const PinkProductCard = ({ product }) => {
    return (
      <div className='group relative bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-200 overflow-hidden h-full flex flex-col'>
        <div className='absolute top-3 right-3 z-10 flex flex-col gap-2'>
          {product.is_active ? <FaCheckCircle className='text-green-600 text-2xl' /> : <FaTimesCircle className='text-red-600 text-2xl' />}
          {product.is_trending && <span className='bg-orange-500 text-white text-xs px-2 py-1 rounded-full font-bold'>Trending</span>}
        </div>

        <div className='w-full h-56 bg-gray-50'>
          <img src={product.image} alt={product.product_name} className='w-full h-full object-cover transition-transform duration-500 group-hover:scale-105' />
        </div>

        <div className='p-4 flex flex-col flex-grow'>
          <h3 className='font-semibold text-lg text-gray-900 line-clamp-2 leading-tight'>{product.product_name}</h3>
          <p className='text-gray-600 text-sm mt-1 line-clamp-2 flex-grow'>{product.sub_title}</p>

          <div className='mt-4 flex items-center gap-3'>
            <p className='text-2xl font-bold text-pink-600'>{displayINRCurrency(product.after_discount_price)}</p>
            {product.discount > 0 && (
              <div className='flex items-center gap-2'>
                <p className='text-sm text-gray-500 line-through'>{displayINRCurrency(product.price)}</p>
                <span className='bg-pink-100 text-pink-700 text-xs font-semibold px-2.5 py-1 rounded'>-{product.discount}%</span>
              </div>
            )}
          </div>

          <button onClick={() => openEditModal(product)} className='mt-5 w-full py-2.5 bg-pink-600 text-white font-medium text-sm rounded-lg hover:bg-pink-700 transition-colors'>
            Edit Product
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className='min-h-screen bg-gray-50'>
      <div className='flex justify-between items-center mb-10'>
        <h1 className='text-2xl md:text-4xl font-extrabold text-pink-800 tracking-wide text-center md:text-left px-6 py-4'>
      All Products
        </h1>

        {/* Create Package Button */}
        <button
          onClick={openCreateModal}
          className='flex items-center gap-3 px-6 py-3 bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-xl shadow-md transition'
        >
          <FaPlus />
          Create Package
        </button>
      </div>
      <div className='px-6 py-8'>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6'>
          {filtered.map(product => (
            <PinkProductCard key={product.product_id} product={product} />
          ))}
        </div>
      </div>

      {/* Floating Add Button - Optional (you didn't have it, but common) */}
      <button
        onClick={openCreateModal}
        className='fixed bottom-8 right-8 w-14 h-14 bg-pink-600 text-white rounded-full shadow-lg hover:bg-pink-700 flex items-center justify-center text-2xl'
      >
        <FaPlus />
      </button>

      {modalOpen && <ProductModal />}
    </div>
  );
};

export default AllProducts;